"use client";

import { Row, Col, Card } from "react-bootstrap";
import { FiUsers, FiTrendingUp, FiZap, FiTarget } from "react-icons/fi";

const Stats = ({ stats = {}, teamCount = 0 }) => {
  const statsData = [
    {
      title: "Team Members",
      value: teamCount,
      icon: <FiUsers size={24} />,
    },
    {
      title: "Avg Productivity",
      value: stats.avgProductivity || "0%",
      icon: <FiTrendingUp size={24} />,
    },
    {
      title: "Productive Time",
      value: stats.productiveTime || "0h 0m",
      icon: <FiZap size={24} />,
    },
    {
      title: "Efficiency",
      value: stats.efficiency || "0%",
      icon: <FiTarget size={24} />,
    },
  ];

  return (
    <Row className="mb-4">
      {statsData.map((stat, index) => (
        <Col sm={6} lg={3} key={index}>
          <Card className="border-0 rounded-3 bg-white p-4 mb-4">
            <div className="d-flex align-items-center mb-2">
              <div className="me-2">{stat.icon}</div>
              <span className="fw-600">{stat.title}</span>
            </div>
            <h2 className="mb-0 fw-900 fs-28">{stat.value}</h2>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default Stats;
